export default class WorkstationLease {
  constructor(namespace) {
    this.namespace = namespace;
    this.id = crypto.randomUUID();
    this.peers = new Map();
    this.storageReady = true;
    this.played = new Map();
    this.disposed = false;
    try {
      this.channel = new BroadcastChannel(namespace);
      this.channel.onmessage = ({ data }) => {
        if (data?.type === 'lease' && typeof data.id === 'string' && /^[a-zA-Z0-9-]{16,80}$/.test(data.id)) this.peers.set(data.id, Date.now());
        if (data?.type === 'played' && typeof data.key === 'string' && data.key.length <= 160) this.played.set(data.key, Date.now());
        while (this.peers.size > 32) this.peers.delete(this.peers.keys().next().value);
        while (this.played.size > 256) this.played.delete(this.played.keys().next().value);
      };
    } catch { this.channel = null; }
  }
  async owner() {
    if (this.disposed) return false;
    this.channel?.postMessage({ type: 'lease', id: this.id });
    const claim = () => {
      if (this.disposed) return false;
      try {
        const previous = JSON.parse(localStorage.getItem(`${this.namespace}:lease`) || 'null');
        if (previous && previous.expires > Date.now() && previous.id !== this.id) return false;
        localStorage.setItem(`${this.namespace}:lease`, JSON.stringify({ id: this.id, expires: Date.now() + 8000 }));
        this.storageReady = true;
        return JSON.parse(localStorage.getItem(`${this.namespace}:lease`)).id === this.id;
      } catch { this.storageReady = false; return null; }
    };
    const result = navigator.locks ? await navigator.locks.request(this.namespace, claim) : claim();
    if (result !== null) return result;
    await new Promise(resolve => setTimeout(resolve, 150));
    if (this.disposed) return false;
    for (const [id, seen] of this.peers) if (seen < Date.now() - 8000) this.peers.delete(id);
    return [this.id, ...this.peers.keys()].sort()[0] === this.id;
  }
  claimEvent(key) {
    if (this.disposed) return false;
    if (this.played.has(key)) return false;
    try {
      const history = JSON.parse(localStorage.getItem(`${this.namespace}:played`) || '{}');
      if (history[key]) return false;
      history[key] = Date.now();
      const bounded = Object.fromEntries(Object.entries(history).filter(([, time]) => time > Date.now() - 86400000).slice(-256));
      localStorage.setItem(`${this.namespace}:played`, JSON.stringify(bounded));
    } catch { this.storageReady = false; }
    this.played.set(key, Date.now());
    if (this.played.size > 256) this.played.delete(this.played.keys().next().value);
    this.channel?.postMessage({ type: 'played', key });
    return true;
  }
  destroy() {
    this.disposed = true;
    this.channel?.close();
    try {
      const lease = JSON.parse(localStorage.getItem(`${this.namespace}:lease`) || 'null');
      if (lease?.id === this.id) localStorage.removeItem(`${this.namespace}:lease`);
    } catch { /* expires without durable storage */ }
  }
}
